import { render } from "./AbsencesModal.vue?vue&type=template&id=13dd221e&scoped=true"
import script from "./AbsencesModal.vue?vue&type=script&lang=js"
export * from "./AbsencesModal.vue?vue&type=script&lang=js"

import "./AbsencesModal.vue?vue&type=style&index=0&id=13dd221e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dd221e"]])

export default __exports__